import axios from 'axios';
import { IDispatcherResultTyped } from '@/catalog-search/Scripts/Validation';

interface IShortUrl {
	code: string;
	redemptionUri: string;
	qrImage: string;
}

export interface IPrintService {
	getShortUrl(path: string): Promise<IDispatcherResultTyped<IShortUrl>>;
}

export class PrintService implements IPrintService {
	public async getShortUrl (path: string): Promise<IDispatcherResultTyped<IShortUrl>> {
		const response = await axios({
			method: 'get',
			url: '/CatalogSearch/ShortUrl',
			params: {
				path
			}
		});

		return response.data;
	}
}
